import { createAsyncThunk } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';
import concat from 'lodash/concat';

import { showLoading, hideLoading } from '../app';
import orchestrateAuthApi from '../../api/orchestrateAuth';
import { toastr } from '../../components/CustomToast';

const getOrgs = createAsyncThunk(
  'orgs/getOrgs',
  async (_, { dispatch, getState, requestId }) => {
    const { currentRequestId, loading } = getState().orgs;
    if (loading !== true || requestId !== currentRequestId) return;
    try {
      dispatch(showLoading());
      const response = await orchestrateAuthApi.orgs.list();
      return { orgs: response.data };
    } catch (err) {
      console.error('ERROR :: getOrgs', err);
    } finally {
      dispatch(hideLoading());
    }
  }
);

const createOrg = createAsyncThunk(
  'orgs/createOrg',
  async (name, { dispatch, getState, requestId }) => {
    const { currentRequestId, loading } = getState().orgs;
    if (loading !== true || requestId !== currentRequestId) return;
    try {
      dispatch(showLoading());
      const response = await orchestrateAuthApi.orgs.create(name);
      const org = response.data;
      toastr.success({ title: `Org "${name}" created` });
      return { orgs: concat(getState().orgs.orgs, org) };
    } catch (err) {
      console.error('ERROR :: createOrg', err);
      toastr.error({ title: 'Error', message: 'Failed to create org' });
    } finally {
      dispatch(hideLoading());
    }
  }
);

const addOrgAppMapping = createAsyncThunk(
  'orgs/addOrgAppMapping',
  async ({ orgId, appName, appOrgId }, { dispatch, getState, requestId }) => {
    const { currentRequestId, loading } = getState().orgs;
    if (loading !== true || requestId !== currentRequestId) return;
    try {
      dispatch(showLoading());
      await orchestrateAuthApi.orgs.addMapping(orgId, appName, appOrgId);
      // Refresh the full org to get updated mappings
      const response = await orchestrateAuthApi.orgs.get(orgId);
      const updated = response.data;
      const orgs = cloneDeep(getState().orgs.orgs).map((o) =>
        o.org_id === orgId ? { ...o, ...updated } : o
      );
      toastr.success({ title: 'App mapping added' });
      return { orgs };
    } catch (err) {
      console.error('ERROR :: addOrgAppMapping', err);
      toastr.error({ title: 'Error', message: 'Failed to add mapping' });
    } finally {
      dispatch(hideLoading());
    }
  }
);

export { getOrgs, createOrg, addOrgAppMapping };
